import React, { Component, Fragment } from "react";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  getAllPossibleGuestMetrics,
  getMyCompanysGuestMetrics,
  addGuestMetric,
  removeGuestMetric
} from "store/state/guest";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import Switch from "@material-ui/core/Switch";
import Tooltip from "@material-ui/core/Tooltip";
import { styles } from "./TooltipStyle";

const PageHeader = styled.p`
  font-size: 18pt;
`;

const PageText = styled.p`
  font-size: 14pt;
  color: #888888;
`;

const StyledTable = styled.table`
  width: 75%;
  border-collapse: collapse;
`;

const StyledRow = styled.tr`
  border-collapse: collapse;
`;

const TopLeftCell = styled.td`
  && {
    border-right: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    border-collapse: collapse;
    width: 30%;
    min-width: 283px;
    padding: 0px 20px 0px 20px;
  }
`;

const TopMiddleCell = styled.td`
  && {
    border-right: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    border-collapse: collapse;
    width: 30%;
    min-width: 283px;
    padding: 0px 20px 0px 20px;
  }
`;

const TopRightCell = styled.td`
  && {
    border-bottom: 1px solid #cccccc;
    border-collapse: collapse;
    width: 30%;
    min-width: 283px;
    padding: 0px 20px 0px 20px;
  }
`;

const MiddleLeftCell = styled.td`
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  width: 30%;
  min-width: 283px;
  border-collapse: collapse;
  padding: 0px 20px 0px 20px;
`;

const MiddleMiddleCell = styled.td`
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  width: 30%;
  min-width: 283px;
  border-collapse: collapse;
  padding: 0px 20px 0px 20px;
`;

const MiddleRightCell = styled.td`
  border-bottom: 1px solid #cccccc;
  width: 30%;
  min-width: 283px;
  border-collapse: collapse;
  padding: 0px 20px 0px 20px;
`;

const BottomLeftCell = styled.td`
  border-right: 1px solid #cccccc;
  width: 30%;
  min-width: 283px;
  border-collapse: collapse;
  padding: 0px 20px 0px 20px;
`;

const BottomMiddleCell = styled.td`
  border-right: 1px solid #cccccc;
  width: 30%;
  min-width: 283px;
  border-collapse: collapse;
  padding: 0px 20px 0px 20px;
`;

const BottomRightCell = styled.td`
  width: 30%;
  min-width: 283px;
  border-collapse: collapse;
  padding: 0px 20px 0px 20px;
`;

const StyledSwitch = styled(Switch)`
  && {
    display: inline-block;
    float: right;
  }
`;

class GuestMetricPage extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.guestState && prevProps.guestState.myCompanysGuestMetrics) {
      if (
        prevProps.guestState.myCompanysGuestMetrics.length !==
        this.props.guestState.myCompanysGuestMetrics.length
      ) {
        this.props.getMyCompanysGuestMetrics();
      }
    }
  }

  componentDidMount() {
    this.props.getAllPossibleGuestMetrics();
    this.props.getMyCompanysGuestMetrics();
  }

  state = {};

  renderControlFor = screenElement => {
    const renderToolTips = false; // CHANGE THIS TO TRUE ONCE CALEB HAS UPDATED SCREEN ELEMENT DESCRIPTIONS
    if (!screenElement) return null;
    const isChecked =
      screenElement.isCore ||
      this.props.guestState.myCompanysGuestMetrics.filter(
        item => item.screenElement.id === screenElement.id
      ).length > 0;
    const isDisabled = screenElement.isCore || !screenElement.isActive;
    let onClickMethod = null;
    if (!isDisabled) {
      if (isChecked) {
        onClickMethod = () =>
          this.props.removeGuestMetric({ screenElementId: screenElement.id });
      } else {
        onClickMethod = () =>
          this.props.addGuestMetric({ screenElementId: screenElement.id });
      }
    }
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          verticalAlign: "middle",
          display: "inline-block"
        }}
      >
        {renderToolTips &&
          <Tooltip
            title={screenElement.description}
            classes={{ tooltip: this.props.classes.lightTooltip }}
          >
            <p style={{ display: "inline-block" }}>{screenElement.title}</p>
          </Tooltip>}
        {!renderToolTips && <p style={{display:"inline-block"}}>{screenElement.title}</p> /* THIS LINE CAN BE REMOVED ONCE CALEB HAS UPDATED SCREEN ELEMENT DESCRIPTIONS */}
        <StyledSwitch
          classes={{
            icon: !isChecked ? this.props.classes.offWhite : null,
            bar: isDisabled ? this.props.classes.lightBlue : null
          }}
          checked={isChecked}
          disabled={isDisabled}
          onClick={onClickMethod}
        />
      </div>
    );
  };

  renderRows = screenElements => {
    const output = [];
    if (screenElements.length < 1) return null;
    let yLocation = "middle";
    for (let i = 0; i < screenElements.length; i += 3) {
      if (i < 3) yLocation = "top";
      else if (i + 3 > screenElements.length) yLocation = "bottom";
      switch (yLocation) {
        case "top":
          output.push(
            <StyledRow>
              <TopLeftCell>
                {this.renderControlFor(screenElements[i])}
              </TopLeftCell>
              <TopMiddleCell>
                {this.renderControlFor(screenElements[i + 1])}
              </TopMiddleCell>
              <TopRightCell>
                {this.renderControlFor(screenElements[i + 2])}
              </TopRightCell>
            </StyledRow>
          );
          break;
        case "middle":
          output.push(
            <StyledRow>
              <MiddleLeftCell>
                {this.renderControlFor(screenElements[i])}
              </MiddleLeftCell>
              <MiddleMiddleCell>
                {this.renderControlFor(screenElements[i + 1])}
              </MiddleMiddleCell>
              <MiddleRightCell>
                {this.renderControlFor(screenElements[i + 2])}
              </MiddleRightCell>
            </StyledRow>
          );
          break;
        case "bottom":
          output.push(
            <StyledRow>
              <BottomLeftCell>
                {this.renderControlFor(screenElements[i])}
              </BottomLeftCell>
              <BottomMiddleCell>
                {this.renderControlFor(screenElements[i + 1])}
              </BottomMiddleCell>
              <BottomRightCell>
                {this.renderControlFor(screenElements[i + 2])}
              </BottomRightCell>
            </StyledRow>
          );
          break;
        default:
          break;
      }
    }
    return output;
  };

  renderAlwaysOnRows = () => {
    if (
      !this.props.guestState ||
      !this.props.guestState.allPossibleGuestMetrics ||
      !this.props.guestState.myCompanysGuestMetrics
    )
      return null;
    let alwaysOnMetrics = this.props.guestState.allPossibleGuestMetrics.filter(
      item => item.isCore
    );
    alwaysOnMetrics = _.sortBy(alwaysOnMetrics, item => item.title);
    return this.renderRows(alwaysOnMetrics);
  };

  renderAvailableRows = () => {
    if (
      !this.props.guestState ||
      !this.props.guestState.allPossibleGuestMetrics ||
      !this.props.guestState.myCompanysGuestMetrics
    )
      return null;
    let availableMetrics = this.props.guestState.allPossibleGuestMetrics.filter(
      item => !item.isCore && item.isActive
    );
    availableMetrics = _.sortBy(availableMetrics, item => item.title);
    return this.renderRows(availableMetrics);
  };

  render() {
    return (
      <Fragment>
        <PageHeader>GUEST METRICS</PageHeader>
        <PageText>
          The following values will <b>always</b> be visible in the deal table
          for each guest, regardless of selections below:
        </PageText>
        <StyledTable>{this.renderAlwaysOnRows()}</StyledTable>
        <br />
        <PageText>
          Select the metrics you would like guests to see on
          <b> Portfolio Deals</b>
        </PageText>
        <br />
        <StyledTable>{this.renderAvailableRows()}</StyledTable>
      </Fragment>
    );
  }
}

function mapStateToProps({ guest, authentication }) {
  return {
    guestState: guest,
    authentication
  };
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    {
      getAllPossibleGuestMetrics,
      getMyCompanysGuestMetrics,
      addGuestMetric,
      removeGuestMetric
    }
  )
)(GuestMetricPage);
